<div class="modal-header">
    <h5 class="modal-title">Reset Password</h5>
    <button type="button" class="btn-close" (click)="closeForm()"></button>
</div>

<form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
    <div class="modal-body">

        <!-- Old Password -->
        <div class="mb-3">
            <label class="form-label">Old Password</label>
            <input type="password" class="form-control" formControlName="oldPassword"  autocomplete="current-password" />
            <div *ngIf="resetForm.get('oldPassword')?.invalid && resetForm.get('oldPassword')?.touched" class="text-danger">
                Old password is required.
            </div>
        </div>

        <!-- New Password -->
        <div class="mb-3">
            <label class="form-label">New Password</label>
            <input type="password" class="form-control" formControlName="password"  autocomplete="current-password" />
            <div *ngIf="resetForm.get('password')?.invalid && resetForm.get('password')?.touched" class="text-danger">
                Password is required and must be at least 8 characters.
            </div>
        </div>

        <!-- Confirm Password -->
        <div class="mb-3">
            <label class="form-label">Confirm Password</label>
            <input type="password" class="form-control" formControlName="confirmPassword"  autocomplete="current-password" />
            <div *ngIf="resetForm.hasError('mismatch') && resetForm.get('confirmPassword')?.touched" class="text-danger">
                Passwords do not match.
            </div>
        </div>

    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary " #myButton (click)="closeForm()">Close </button>
        <button type="submit" class="btn btn-primary" [disabled]="resetForm.invalid || isProcessing">Reset Password</button>
    </div>
</form>
